var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33049 0.000396729H14.6695C18.0705 0.000396729 19.9905 1.9294 20.0005 5.3304V14.6704C20.0005 18.0704 18.0705 20.0004 14.6695 20.0004H5.33049C1.92949 20.0004 0.000488281 18.0704 0.000488281 14.6704V5.3304C0.000488281 1.9294 1.92949 0.000396729 5.33049 0.000396729ZM10.0496 15.8604C10.4806 15.8604 10.8396 15.5404 10.8796 15.1104V4.9204C10.9196 4.6104 10.7706 4.2994 10.5006 4.1304C10.2196 3.9604 9.87956 3.9604 9.61056 4.1304C9.33956 4.2994 9.19056 4.6104 9.21956 4.9204V15.1104C9.27056 15.5404 9.62956 15.8604 10.0496 15.8604ZM14.6506 15.8604C15.0706 15.8604 15.4296 15.5404 15.4806 15.1104V11.8304C15.5096 11.5094 15.3606 11.2104 15.0896 11.0404C14.8206 10.8704 14.4806 10.8704 14.2006 11.0404C13.9296 11.2104 13.7806 11.5094 13.8206 11.8304V15.1104C13.8606 15.5404 14.2196 15.8604 14.6506 15.8604ZM6.21966 15.1104C6.17966 15.5404 5.82066 15.8604 5.38966 15.8604C4.95966 15.8604 4.59966 15.5404 4.56066 15.1104V8.2004C4.53066 7.8894 4.67966 7.5804 4.95066 7.4104C5.21966 7.2404 5.56066 7.2404 5.83066 7.4104C6.09966 7.5804 6.25066 7.8894 6.21966 8.2004V15.1104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.65e2ac75.svg";
export { ForwardRef as ReactComponent };